const findHTMLElements = (selector: string) => document.querySelectorAll(selector) as NodeListOf<HTMLElement>

const findHTMLElement = (selector: string) => {
  const el = document.querySelector(selector)

  if (!el) return

  return el as HTMLElement
}

const getHiddenPosts = () =>
  Array.from(findHTMLElements('#bloglist .case-wrapper')).filter((el) => el.offsetParent === null)

const getVisiblePosts = () =>
  Array.from(findHTMLElements('#bloglist .case-wrapper')).filter((el) => el.offsetParent !== null)

const loadMorePosts = () => {
  let focusitem

  const blogsToShowData = findHTMLElement('#js-blog-count')?.getAttribute('data-blog-count')
  const blogsToShow = blogsToShowData ? Number(blogsToShowData) : 999
  const blockCounter = findHTMLElement('.blogCount')
  const totalCount = findHTMLElements('#bloglist .case-wrapper').length
  const loadMoreBtn = findHTMLElement('#blogloadmore')

  const listItemsHidden = getHiddenPosts()
  const toShow = Math.min(listItemsHidden.length, blogsToShow)

  for (var i = 0; i < toShow; i++) {
    listItemsHidden[i].style.display = 'list-item';
    listItemsHidden[i].classList.remove('rs_skip');
    if (i === 0) {
      focusitem = listItemsHidden[i]
    }
  }

  const listItemsVisible = getVisiblePosts()

  if (blockCounter) {
    blockCounter.innerText = String(listItemsVisible.length)
  }

  if (loadMoreBtn && totalCount == listItemsVisible.length) {
    loadMoreBtn.style.display = 'none'
  }

  if (focusitem) {
    focusitem.focus()
  }
}

document.getElementById('blogloadmore')?.addEventListener('click', loadMorePosts)
